<xi-generic-modal
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="600px"
  (onClose)="onCancel()"
>
  <div slot="children">
    <xi-basic-tile
      [hasTopBar]="false"
      [stretch]="true"
      [isInteractive]="false"
      class="test-document-generator__basic-tile"
    >
      <div slot="children">
        <div class="xi-modal__container test-document-generator__container">
          <h2 class="xi-modal__title">Test Document Generator</h2>

          <div class="xi-modal__content" [formGroup]="formGroup">
            <div class="test-document-generator__header">
              <h5>Generate new Document</h5>
            </div>

            <div class="test-document-generator__field">
              <div class="test-document-generator__field-label">Generate:</div>
              <div class="test-document-generator__input-set">
                <app-lex-horizontal-stepper [(value)]="count" [scale]="countScale">
                </app-lex-horizontal-stepper>
                <xi-dropdown
                  formControlName="typeOfResponse"
                  name="typeOfResponse"
                  [data]="responseTypeOptions"
                  [stretch]="true"
                ></xi-dropdown>
              </div>
            </div>

            <div class="test-document-generator__field">
              <div class="test-document-generator__field-label">About:</div>
              <div class="test-document-generator__input-field">
                <xi-input-field
                  formControlName="about"
                  required
                  [stretch]="true"
                  [status]="errorObjects.about"
                >
                </xi-input-field>
              </div>
            </div>

            <div class="test-document-generator__field">
              <div class="test-document-generator__field-label">In the style of:</div>
              <div class="test-document-generator__input-field">
                <xi-dropdown
                  formControlName="inStyleOf"
                  name="inStyleOf"
                  [data]="styleOptions"
                  [stretch]="true"
                ></xi-dropdown>
              </div>
            </div>

            <div class="test-document-generator__field">
              <div class="test-document-generator__field-label">With sentiment:</div>
              <div class="test-document-generator__input-set" formGroupName="sentiment">
                <xi-checkbox label="Positive" formControlName="positive"></xi-checkbox>
                <xi-checkbox label="Negative" formControlName="negative"></xi-checkbox>
                <xi-checkbox label="Neutral" formControlName="neutral"> </xi-checkbox>
              </div>
            </div>

            <div class="test-document-generator__field">
              <div class="test-document-generator__field-label">Focused on:<br />(optional)</div>
              <div class="test-document-generator__input-field">
                <xi-input-field
                  formControlName="focus"
                  [stretch]="true"
                  [status]="errorObjects.focus"
                ></xi-input-field>
              </div>
            </div>

            <div class="test-document-generator__field">
              <div class="test-document-generator__field-label">Query match:</div>
              <div class="test-document-generator__input-set">
                @for (radio of queryMatchRadios; track radio; let i = $index) {
                  <xi-radio
                    [value]="radio.value"
                    [label]="radio.label"
                    name="queryMatchRadio"
                    formControlName="queryMatch"
                  ></xi-radio>
                }
              </div>
            </div>
          </div>

          <div class="xi-modal__actions test-document-generator__actions">
            <xi-default-button
              type="button"
              text="Cancel"
              fill="text"
              (onClick)="onCancel()"
            ></xi-default-button>
            @if (isEvaluationInProgress) {
              <div class="test-document-generator__evalution-loading">
                <xi-animation
                  [height]="75"
                  [width]="75"
                  [loop]="true"
                  animation="cx_loader"
                ></xi-animation>
              </div>
            }
            <xi-default-button
              text="Generate New"
              [disabled]="isEvaluationInProgress || formGroup.invalid"
              (onClick)="onGenerate()"
            ></xi-default-button>
          </div>
        </div>
      </div>
    </xi-basic-tile>
  </div>
</xi-generic-modal>
